module.exports = __webpack_public_path__ + "img/45.55dd4fde.jpg";